import { createContext, use } from 'react';

export type FeatureKey = 'guests' | 'local_recording' | 'transcription';

export type MeetingFeatures = Record<FeatureKey, boolean>;

export const NO_FEATURES: MeetingFeatures = {
    guests: false,
    local_recording: false,
    transcription: false,
};

export const MeetingFeaturesContext = createContext<MeetingFeatures>(NO_FEATURES);

export function useMeetingFeatures() {
    return use(MeetingFeaturesContext);
}

export type MeetingSummary = { roomName: string; features: MeetingFeatures };

export async function fetchMeeting(roomName: string, signal?: AbortSignal): Promise<MeetingSummary | null> {
    const response = await fetch(`/api/meetings/${encodeURIComponent(roomName)}`, { signal });
    if (response.status === 404) return null;
    if (!response.ok) throw new Error(`${String(response.status)} ${await response.text()}`);
    return (await response.json()) as MeetingSummary;
}
